// extracted by mini-css-extract-plugin
export default {"container":"GlobalSearch_container__qFgYm","searchIcon":"GlobalSearch_searchIcon__z86tW","crossIcon":"GlobalSearch_crossIcon__zTpDV"};